import { render, staticRenderFns } from "./V2ImageUploader.vue?vue&type=template&id=1bb2d75f&scoped=true&"
import script from "./V2ImageUploader.vue?vue&type=script&lang=ts&"
export * from "./V2ImageUploader.vue?vue&type=script&lang=ts&"
import style0 from "./V2ImageUploader.vue?vue&type=style&index=0&id=1bb2d75f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb2d75f",
  null
  
)

export default component.exports